import React from "react";
import style from "./styles.module.scss";
import { UmbracoImage } from "@components/Image/UmbracoImage/UmbracoImage";
import { ImageProcessorParams } from "@helpers/image-processor/serialize-query-parameters";
import { ImageField } from "@helpers/interfaces/image";
import { Box } from "@components/Box/Box";
import { PrimitiveProps } from "@helpers/interfaces/primitive";
import classnames from "classnames";

export interface UmbracoBackgroundImageProps extends PrimitiveProps {
  params?: ImageProcessorParams | ImageProcessorParams[];
  image: ImageField;
  width?: string | number | string[] | number[];
  height?: string | number | string[] | number[];
  lazyLoadOffset?: number;
  className?: string;
  onLoad?: () => void;
}

const UmbracoBackgroundImage: React.FC<UmbracoBackgroundImageProps> = ({
  children,
  className,
  onLoad,
  ...otherProps
}) => {
  if (!otherProps.image) {
    return null;
  }

  return (
    <Box className={classnames(style.backgroundImage, className)}>
      <UmbracoImage
        isCover
        alt={otherProps.image?.Name ?? ""}
        {...otherProps}
        className={style.image}
        {...(onLoad && { onLoad: onLoad })}
      />
      <Box className={style.contentWrapper}>{children}</Box>
    </Box>
  );
};

UmbracoBackgroundImage.defaultProps = {};

export { UmbracoBackgroundImage };
